import {
  Alert,
  Button,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import { ErrorMessage, Form, Formik } from "formik";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
  PayPalSettingInitialValues,
  PayPalSettingValidationSchema,
  PayPalSetting,
  EditPayPalSettingValidationSchema,
} from "../../../models/features/Gravity/Gravity";

export interface AddDialogProps {
  isEdit: boolean;
  isOpen: boolean;
  isLoading: boolean;
  errorMessage: string;
  onClose: any;
  setting?: PayPalSetting;
  handleSettingSubmit: (values: PayPalSetting) => void;
}

export const AddPayPalSettingDialog: React.FunctionComponent<AddDialogProps> = (
  props
) => {
  const handleOnSubmit = (values: PayPalSetting) => {
    props.handleSettingSubmit(values);
  };

  return (
    <Dialog
      open={props.isOpen}
      onClose={() => {
        props.onClose();
      }}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: 0,
          paddingLeft: "39px",
          paddingRight: "39px",
        }}
      >
        <h4>{props.isEdit ? "Edit" : "Add"} PayPal Setting</h4>
        <IconButton
          onClick={() => {
            props.onClose();
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Container>
          <Formik
            initialValues={props.setting ?? PayPalSettingInitialValues}
            validationSchema={
              props.isEdit
                ? EditPayPalSettingValidationSchema
                : PayPalSettingValidationSchema
            }
            onSubmit={(values) => {
              handleOnSubmit(values);
            }}
          >
            {({ values, errors, handleChange, handleBlur }) => (
              <>
                <Form>
                  <Grid container spacing={3} alignItems="center" mt={1}>
                    <Grid item xs={3}>
                      <Typography>Setting Name:</Typography>
                    </Grid>

                    <Grid item xs={9}>
                      <TextField
                        fullWidth
                        placeholder="setting Name"
                        size="small"
                        variant="outlined"
                        name="settingName"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.settingName}
                      />
                      <ErrorMessage
                        className="error-msg"
                        component={"div"}
                        name="settingName"
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <Typography>Client Id:</Typography>
                    </Grid>
                    <Grid item xs={9}>
                      <TextField
                        fullWidth
                        placeholder="Client Id"
                        size="small"
                        variant="outlined"
                        name="clientId"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.clientId}
                      />
                      <ErrorMessage
                        className="error-msg"
                        component={"div"}
                        name="clientId"
                      />
                    </Grid>
                    {!props.isEdit && (
                      <>
                        <Grid item xs={3}>
                          <Typography>Secret Key</Typography>
                        </Grid>
                        <Grid item xs={9}>
                          <TextField
                            fullWidth
                            placeholder="Secret Key"
                            size="small"
                            variant="outlined"
                            name="secretKey"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.secretKey}
                          />
                          <ErrorMessage
                            className="error-msg"
                            component={"div"}
                            name="secretKey"
                          />
                        </Grid>
                      </>
                    )}
                    {props.errorMessage.length > 0 ? (
                      <Grid item xs={12}>
                        <Alert severity="error">{props.errorMessage}</Alert>{" "}
                      </Grid>
                    ) : (
                      ""
                    )}
                  </Grid>
                  <DialogActions
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      mt: 2,
                    }}
                  >
                    <Button
                      autoFocus
                      variant="contained"
                      color="error"
                      onClick={() => {
                        props.onClose();
                      }}
                    >
                      Close
                    </Button>
                    <Button
                      variant="contained"
                      type="submit"
                      onClick={() => {
                        console.log(errors);
                        console.log(values);
                      }}
                      endIcon={
                        props.isLoading ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : (
                          <></>
                        )
                      }
                      disabled={props.isLoading}
                    >
                      Save
                    </Button>
                  </DialogActions>
                </Form>
              </>
            )}
          </Formik>
        </Container>
      </DialogContent>
    </Dialog>
  );
};
